import React from "react";
import PaperWorkNeeded from "../../PicesForPages/PaperWorkNeeded.png";
import FreeConsultation from "../Form/FreeConsultation";
import MortgageCalculator from "../CalculatorAndChart/mortgageCalculator";

function PaperWork() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={PaperWorkNeeded}
          alt="NewsPaperImage"
          className="background-video"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Necessary Paperwork</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              When applying for a loan, you will need to submit detailed proof
              of your financial background to the lender. The lender will
              request a credit report from a credit bureau and confirm the
              information you provide in your loan application. Be ready to
              provide the following:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>Social Security numbers for you and any co-borrowers</li>
              <li>
                Bank statements from checking and savings accounts for the last
                two months
              </li>
              <li>
                Documentation of any other assets like stocks, bonds, or
                retirement savings (e.g., 401k or 403b)
              </li>
              <li>Recent pay stubs</li>
              <li>
                W-2 forms or tax returns from the past two years to confirm your
                income and employment
              </li>
              <li>
                The name and contact details of someone who can verify your
                employment
              </li>
              <li>A record of your residence for the last two years</li>
              <li>A sales agreement for purchasing a new home</li>
              <li>
                Homeowners association contact information if the property is a
                condo or part of an association
              </li>
            </ul>
            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
      <MortgageCalculator />
    </div>
  );
}

export default PaperWork;
